import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

import S from './Text.styled'

const fontWeights = ['normal', 'medium', 'semibold', 'bold', 'heavy', 'black']

const fontSizes = ['xl', 'l', 'm', 's', 'xs', 'xxs']

const textType = ['headline', 'copy', 'cta']

const Text = forwardRef(
  (
    {
      as: As = 'p',
      className = '',
      weight = 'medium',
      size = 'l',
      isFixedSize = false,
      smSize,
      mdSize,
      lgSize,
      type = 'copy',
      text,
      children,
      headline = '',
      useCustomFont = false,
      ...rest
    },
    ref
  ) => {
    const StyledText = S.Text.withComponent(As)

    return (
      <StyledText
        ref={ref}
        className={className}
        weight={weight}
        size={size}
        isFixedSize={isFixedSize}
        type={type}
        smSize={smSize}
        mdSize={mdSize}
        lgSize={lgSize}
        headline={headline}
        useCustomFont={useCustomFont}
        {...rest}
      >
        {text && text}
        {children && children}
      </StyledText>
    )
  }
)

Text.propTypes = {
  as: PropTypes.string,
  className: PropTypes.string,
  weight: PropTypes.oneOf(fontWeights),
  size: PropTypes.oneOf(fontSizes),
  isFixedSize: PropTypes.bool,
  type: PropTypes.oneOf(textType),
  children: PropTypes.node,
  smSize: PropTypes.oneOf(fontSizes),
  mdSize: PropTypes.oneOf(fontSizes),
  lgSize: PropTypes.oneOf(fontSizes),
  text: PropTypes.string,
  headline: PropTypes.string,
  useCustomFont: PropTypes.bool,
}

export default Text
